import { GeneralForListSchema } from "../generated";

export const initialGeneralForList = (): GeneralForListSchema => ({ value: 0, label: "　" });
